import { Page } from '../../types'

const detailsOfPrevention: Page[] = [
        {
        pageType: 'question',
        title: 'Do you perform any upstream prevention measures?',
        name: 'upstream-prevention',
        description:
            'Where control improvements are made following the insights gained from proactive detection activity (e.g. fraud measurement or data matching exercises) they may generate ‘Upstream Prevention Savings’. Such savings are calculated on the basis of a reduction in the measured level of fraud/error in the particular business area, after the implementation of the additional control measures. Values here can include savings calculated from a reduction in both the fraud and error rate.\n'+
            'The savings methodology used should either be assured by the Prevention Panel, or refer to an approved methodology within the Prevention Panel Methodology Bank',
        questions: [
            {
                questionType: 'radio',
                title: 'Do you perform any upstream prevention measures',
                name: 'upstream-prevention-radio',
                options: ['Yes', 'No'],
                rules: {
                    required: true
                }
            }
        ]
    },
    {
        pageType: 'question',
        title: 'Upstream prevention',
        name: 'details-of-prevention',
        description:
            'Where control improvements are made following the insights gained from proactive detection activity (e.g. fraud measurement or data matching exercises) they may generate ‘Upstream Prevention Savings’. Such savings are calculated on the basis of a reduction in the measured level of fraud/error in the particular business area, after the implementation of the additional control measures. Values here can include savings calculated from a reduction in both the fraud and error rate.\n'+
            'The savings methodology used should either be assured by the Prevention Panel, or refer to an approved methodology within the Prevention Panel Methodology Bank.\n'+
            'Entries should also include selections from the Upstream Prevention typology dropdowns:\n'+
            '<ul><li>the business area affected by the fraud</li><li>the prevention activity or type of control implemented that enabled a saving and/or reduction in the fraud/error rate</li><li>whether the fraud related to a COVID-19 scheme or activity</li></ul><br/>',
        disabled: [
            {
                field: 'upstream-prevention-radio',
                condition: 'equals', // optional
                value: 'No'
            }
        ],
            questions: [
                {
                    questionType: 'select',
                    title: 'Which spending area was the fraud prevented in?',
                    name: 'upstream-prevention-fraud-area',
                    detailsHeading: 'Help with spending areas',
                    detailsContent: ' <b>Procurement:</b> Goods or services bought by public sector organisations (including suppliers)'+
                    ' <br/><b>Personnel:</b> Employees (including contractors and agency workers).'+
                    ' <br/><b>Subsidies:</b> Support or incentives given by the government.'+
                    ' <br/><b>Grants:</b> Money given by a public sector organisation for a specific purpose.'+
                    ' <br/><b>Loans & credit guarantees:</b> Money given by a public sector organisation for a specific purpose.'+
                    ' <br/><b>Charges & other non-tax income:</b> Money owed to public sector organisations (for example, court fines or prescription fees)'+
                    ' <br/><b>Licenses and permits:</b> Personal or business licenses (for example, a Blue Badge or Surveyor license)' +
                    ' <br/><b>Tax & Duties:</b> Mandatory government charge for goods, income or services'+
                    ' <br/><b>Benefits:</b> Money given by the government to support members of the public'+
                    ' <br/><b>Special Payments:</b> Money given in unique or specific circumstances (for example, compensation)',
                    options: ['Procurement','Personnel','Subsidies','Grants','Loans & credit gurantees','Charges & other non-tax income','Licences and permits','Tax & Duties','Benefits','Special payments'],
                    hintOption: 'Select an option',
                    rules: {
                        required: true
                    },
                    errorMessages: { required: 'This field is mandatory' }
                },  
                {
                    questionType: 'checkbox',
                    title: 'What was the prevention activity?',
                    name: 'upstream-prevention-support',
                    detailsHeading: 'Help with terms',
                    detailsContent: '<b>Eligibility criteria & rules:</b> using or changing eligibility rules for roles, products or services.'+
                    '</br><b>Manual compliance checks:</b> using manual reviews or investigations to review compliance with eligibility criteria.'+
                    '</br><b> Automated compliance checks:</b> using technology to review compliance with eligibility.'+
                    '</br><b>Risk scoring & enhanced due diligence:</b> using risk scores to enhance due diligence.'+
                    '</br><b>Cyber security:</b> using or improving cyber security systems.'+
                    '</br><b>Biometrics:</b> using or improving identification using biometrics (for example, fingerprints).'+
                    '</br><b>Behavioural insights:</b> using user behaviour to predict or deter fraudulent activity.'+
                    '</br><b>External audit or review:</b> independent reviews by experts or skilled professionals.'+
                    '</br><b>Governance:</b> using or updating decision-making processes in the organisation e.g. segregation of duties.'+
                    '</br><b>Training and awareness:</b> improving organisational knowledge and awareness through training e.g. on policies, risks or other communications campaigns.',
        
                    hint: 'Tick all that apply',
                    options: ['Eligibility criteria & rules', 'Manual compliance checks', 'Automated compliance checks', 'Risk scoring & enhanced due diligence','Cyber security','Biometrics','Behavioural insights','External audit or review','Governance','Training and awareness'],
                    rules: { required: true }
                },
                {
                questionType: 'instanceInput',
                title: 'How many instances were prevented?',
                name: 'upstream-prevention-impact',
                txt: `Total number of instances.`,
                rules: {
                    required: true
                }
            },
            {
                questionType: 'costInput',
                title: 'What was the value of the prevented fraud?',
                name: 'upstream-prevention-estimated-total',
                txt: `Total value`,
                rules: {
                    required: false
                }
            },   
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'upstream-prevention-comments',
                hint: `Please ensure you do not include any personal or sensitive information`,
                rules: {
                    required: false
                }
            }
        ]
    }
]
export default detailsOfPrevention

